import { render } from "./AdministratorPage.vue?vue&type=template&id=24cf3e90&scoped=true"
import script from "./AdministratorPage.vue?vue&type=script&lang=js"
export * from "./AdministratorPage.vue?vue&type=script&lang=js"

import "./AdministratorPage.vue?vue&type=style&index=0&id=24cf3e90&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cf3e90"]])

export default __exports__